import React from "react";
import "./style.css";
import Aos from "aos";
import "aos/dist/aos.css";
import handleViewport from "react-in-viewport";

class Home extends React.Component {
  componentDidMount() {
    Aos.init({ duration: 3000, once: true });
  }
  render() {
    var nameColor = "rgb(255, 65, 31)";
    if (this.props.switchState) {
      nameColor = "rgb(0,120,255)";
    }
    return (
      <div
        className="home"
        id="home"
        //style={{ backgroundImage: `url(${homewallpaper})` }}
      >
        {/* <div className="home-header"></div> */}
        <div data-aos="fade-in" className="home-body">
          <div className="home-items">
            <div className="home-item1">
              Hello, I'm&nbsp;
              <span style={{ color: `${nameColor}` }}>Sagar Dalal.</span>
            </div>
            <div className="home-item2">I'm a React developer.</div>
          </div>
          {/* <div className="home-wallpaper-holder">
              <img alt="home" className="home-wallpaper" src={homeimage}></img>
            </div> */}
        </div>
      </div>
    );
  }
}
//Using Viewport
const MySection1 = handleViewport(Home, { rootMargin: "-50%" });

export default MySection1;
